/**
 * Constructores de rutas de RTDB.
 *
 * Cualquier ruta que se escriba a mano en dos sitios acaba divergiendo, y una ruta
 * mal escrita en RTDB no falla: crea silenciosamente un nodo nuevo que las reglas
 * rechazan con un error que no dice nada. Todas las rutas salen de aquí.
 */
export const DEVICES_ROOT = 'devices';
export const SESSIONS_ROOT = 'sessions';
export function devicePath(deviceId) {
    return `${DEVICES_ROOT}/${deviceId}`;
}
export function sessionPath(sessionId) {
    return `${SESSIONS_ROOT}/${sessionId}`;
}
export function sessionOfferPath(sessionId) {
    return `${sessionPath(sessionId)}/offer`;
}
export function sessionAnswerPath(sessionId) {
    return `${sessionPath(sessionId)}/answer`;
}
export function sessionStatePath(sessionId) {
    return `${sessionPath(sessionId)}/state`;
}
export function sessionCandidatesPath(sessionId, role) {
    return `${sessionPath(sessionId)}/candidates/${role}`;
}
/** Nodo sintético de la SDK que refleja si hay conexión con RTDB. */
export const INFO_CONNECTED_PATH = '.info/connected';
/** Nombres de los campos por los que se consulta. Deben coincidir con `.indexOn`. */
export const INDEXED_FIELDS = {
    deviceOwner: 'ownerUid',
    sessionDevice: 'deviceId',
};
//# sourceMappingURL=paths.js.map